import styles from './styles.module.scss';

import { useContext, useEffect, useState } from 'react';
import TrilogicIconLogin from '../../../../assets/images/icons/trilogic-icon-login.png';
import IfrsIcon from '../../../../assets/images/icons/ifrs-canoas-logotipo-horizontal.png';
import GoogleIcon from '../../../../assets/images/icons/google-icon.svg';
import MoodleIcon from '../../../../assets/images/icons/moodle-icon.png';
import MoodleIconHorizontal from '../../../../assets/images/icons/moodle-icon.svg';
import { NavLink, useNavigate } from 'react-router-dom';
import { LoginBox } from '../../../../components/LoginBox';
import { useGoogleLogin } from '@react-oauth/google';
import { MessageContext } from '../../../../providers/MessageProvider';
import { getMoodleServers, authenticate } from './requestHandlers';
import { MoodleServer } from './types';
import { Error, User } from '../../../../types';
import {
    prepareUserObject,
    saveSessionCredentials,
    verifyRoutePermissions
} from '../../../../globalFunctions';
import { LoadingContext } from '../../../../providers/LoadingProvider';

export const SignInRoute = () => {
    const [userAuth, setUserAuth] = useState<User>({} as User);
    const { setOpenMessage, setMessage } = useContext(MessageContext);
    const { setIsLoadingContent } = useContext(LoadingContext);
    const navigate = useNavigate();

    // Get the URL search params
    const searchParams = new URLSearchParams(window.location.hash.split('?')[1]);
    const openLoginBoxValue = searchParams.get('open') == 'true' ? true : false;

    const [openLoginBox, setOpenLoginBox] = useState<boolean>(openLoginBoxValue ?? false);
    const [moodleServers, setMoodleServers] = useState<MoodleServer[]>([]);
    const [selectedMoodleServer, setSelectedMoodleServer] = useState<string>('');
    const [loginType, setLoginType] = useState<'email' | 'google' | 'moodle'>('email');
    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [passwordType, setPasswordType] = useState<'password' | 'text'>('password');

    const handleLogin = () => {
        setOpenLoginBox(current => !current);
    };

    const validateInputCredentials = () => {
        if (loginType === 'moodle' && selectedMoodleServer === '') {
            setMessage({
                type: 'warning',
                content: `Selecione uma instituição de ensino`
            });
            setOpenMessage(true);

            return false;
        } else if (username.trim() === '' || password.trim() === '') {
            const usernameFieldName = loginType === 'moodle' ? 'usuário' : 'e-mail';

            setMessage({
                type: 'warning',
                content: `Preencha os campos de ${usernameFieldName} e senha`
            });
            setOpenMessage(true);

            return false;
        } else {
            return true;
        }
    };

    const handleDefaultLogin = async (event: React.ChangeEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (validateInputCredentials()) {
            setIsLoadingContent(true);

            const result = await authenticate({
                login_type: 'email',
                email: username,
                password: password
            });

            setIsLoadingContent(false);
            if (result && typeof result === 'object' && !Object.keys(result).includes('error')) {
                afterLogin(result as User);
            } else {
                const error = result as Error;

                setMessage({
                    type: 'error',
                    content: error.message
                });
                setOpenMessage(true);
            }

        }
    };
//arrancar fora

    const handleGoogleLogin = useGoogleLogin({
        onSuccess: async response => {
            setIsLoadingContent(true);

            const result = await authenticate({
                login_type: 'google',
                google_access_token: response.access_token
            });

            setIsLoadingContent(false);
            if (result && typeof result === 'object' && !Object.keys(result).includes('error')) {
                afterLogin(result as User);
            } else {
                const error = result as Error;

                setMessage({
                    type: 'error',
                    content: error.message
                });
                setOpenMessage(true);
            }

        },
        onError: async error => {
            const message = 'Erro de conexão com a API do Google';

            setMessage({
                type: 'error',
                content: message
            });
            setOpenMessage(true);

            console.error({
                message: message,
                error: error
            });
        }
    }); 
   
    //arrancar fora

    const handleMoodleLogin = async (event: React.ChangeEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (validateInputCredentials()) {
            setIsLoadingContent(true);

            const result = await authenticate({
                login_type: 'moodle',
                moodle_username: username,
                moodle_password: password,
                moodle_server: selectedMoodleServer
            });

            if (result && typeof result === 'object' && !Object.keys(result).includes('error')) {
                afterLogin(result as User);
            } else {
                const error = result as Error;

                setMessage({
                    type: 'error',
                    content: error.message
                });
                setOpenMessage(true);
            }

            setIsLoadingContent(false);
        }
    };

    const handleMoodleLoginType = async () => {
        setLoginType('moodle');

        if (moodleServers.length === 0) {
            const result = await getMoodleServers();

            if (result && typeof result === 'object' && !Object.keys(result).includes('error')) {
                setMoodleServers(result as MoodleServer[]);
            } else {
                const error = result as Error;

                setMessage({
                    type: 'error',
                    content: error.message
                });
                setOpenMessage(true);
            }
        }
    };

    const createMoodleServerOption = (moodleServer: MoodleServer) => {
        return (
            <option key={moodleServer.moodle_server} value={moodleServer.moodle_server}>
                {moodleServer.slug} ({moodleServer.moodle_server})
            </option>
        );
    };

    const togglePassword = () => {
        if (passwordType === 'password') {
            setPasswordType('text');
        } else {
            setPasswordType('password');
        }
    };

    const afterLogin = (user: User) => {
        user = prepareUserObject(user);
        setUserAuth(user);
        saveSessionCredentials(user);

        if (
            user.gender === null ||
            user.gender === undefined ||
            user.image === null ||
            user.image === undefined ||
            !user.lgpd_agreed ||
            user.lgpd_agreed === undefined
        ) {
            navigate('/auth/user/pending-update');
        } else {
            navigate('/');
        }
    };

    useEffect(() => {
        verifyRoutePermissions(['not.auth'], navigate);
    }, []);

    return (
        <div className={styles.wrapper}>

            <div className={styles.mainLeft}>
                <button className={styles.loginBox} onClick={() => {
                    // Garante que a caixa de login abra 
                    setOpenLoginBox(true);
                    handleMoodleLoginType();

                  } }>

                    <div className={`fa fa-user-circle ${styles.user}`} />
                    <div className={styles.login}>Jogar</div>
                </button>
            </div>

            <div className={styles.mainRight}>
                <img src={TrilogicIconLogin} alt='Logo do Trilogic' />
            </div>

            <LoginBox open={openLoginBox}>
                {loginType === 'moodle' ? (
                    <>
                        <div className={styles.nav}>
                           {/* 
                            <div
                                className={`fa fa-chevron-left ${styles.green}`}
                                aria-hidden='true'
                                onClick={() => setLoginType('email')}
                            ></div>
                           */}
                            <div
                                className='fa fa-times'
                                aria-hidden='true'
                                onClick={() => setOpenLoginBox(current => !current)}
                            ></div>
                        </div>

                        <div className={`${styles.loginOption} ${styles.credentials}`}>
                            <div className={`${styles.optionHeader} ${styles.centralize}`}>
                                <img
                                    className={styles.horizontalImage}
                                    src={MoodleIconHorizontal}
                                    alt='Ícone do Moodle'
                                />
                            </div>

                            <form onSubmit={handleMoodleLogin}>
                                <div className={styles.groupField}>
                                    <label htmlFor='moodleServer'>Instituição</label>
                                    <select
                                        id='moodleServer'
                                        name='moodleServer'
                                        defaultValue={selectedMoodleServer}
                                        onChange={event =>
                                            setSelectedMoodleServer(event.target.value)
                                        }
                                    >
                                        <option value=''>
                                            Selecione uma instituição
                                        </option>
                                        {moodleServers.map(createMoodleServerOption)}
                                    </select>
                                </div>

                                <div className={styles.groupField}>
                                    <label htmlFor='username'>Identificação de usuário</label>
                                    <input
                                        type='text'
                                        id='username'
                                        name='username'
                                        value={username}
                                        onChange={event => setUsername(event.target.value)}
                                    />
                                </div>

                                <div className={styles.groupField}>
                                    <label htmlFor='password'>Senha</label>
                                    <div className={styles.passwordField}>
                                        <input
                                            type={passwordType}
                                            id='password'
                                            name='password'
                                            value={password}
                                            onChange={event => setPassword(event.target.value)}
                                        />
                                        <div
                                            className={`fa ${
                                                passwordType === 'password'
                                                    ? 'fa-eye-slash'
                                                    : 'fa-eye'
                                            }`}
                                            onClick={togglePassword}
                                        ></div>
                                    </div>
                                </div>

                                <button
                                    type='submit'
                                    className={`${styles.loginOption} ${styles.submitButton}`}
                                >
                                    Entrar
                                </button>
                            </form>
                        </div>
                    </>
                ) : (
                    <>
                        <div className={styles.nav}>
                            <br />
                            <div
                                className='fa fa-times'
                                aria-hidden='true'
                                onClick={() => setOpenLoginBox(current => !current)}
                            ></div>
                        </div>

                        <div className={`${styles.loginOption} ${styles.credentials}`}>
                            <div className={`${styles.optionHeader}`}>
                                <img
                                    className={styles.horizontalImage}
                                    src={IfrsIcon}
                                    alt='Ícone do IFRS - Campus Canoas'
                                />
                            </div>

                            <form onSubmit={handleDefaultLogin}>
                                <div className={styles.groupField}>
                                    <label htmlFor='username'>E-mail</label>
                                    <input
                                        type='email'
                                        id='username'
                                        name='username'
                                        value={username}
                                        onChange={event => setUsername(event.target.value)}
                                    />
                                </div>

                                <div className={styles.groupField}>
                                    <label htmlFor='password'>Senha</label>
                                    <div className={styles.passwordField}>
                                        <input
                                            type={passwordType}
                                            id='password'
                                            name='password'
                                            value={password}
                                            onChange={event => setPassword(event.target.value)}
                                        />
                                        <div
                                            className={`fa ${
                                                passwordType === 'password'
                                                    ? 'fa-eye-slash'
                                                    : 'fa-eye'
                                            }`}
                                            onClick={togglePassword}
                                        ></div>
                                    </div>
                                </div>

                                <div className={styles.links}>
                                    <NavLink to='/auth/reset-password'>Esqueceu sua senha?</NavLink>
                                    <NavLink to='/auth/sign-up'>Cadastrar-se</NavLink>
                                </div>

                                <button
                                    type='submit'
                                    className={`${styles.loginOption} ${styles.submitButton}`}
                                >
                                    Entrar
                                </button>
                            </form>
                        </div>

                        <div className={styles.divider}>
                            <hr className={styles.dividerBar} />
                            <span>ou</span>
                            <hr className={styles.dividerBar} />
                        </div>
{/*remover depois que o moodle voltar a funcionar direito 
                        <button
                            type='button'
                            className={styles.loginOption}
                            onClick={() => handleGoogleLogin()}
                        >
                            <img src={GoogleIcon} alt='Ícone do Google' />
                            Entrar com o Google
                        </button>
*/}
                        <button
                            type='button'
                            className={styles.loginOption}
                            onClick={() => handleMoodleLoginType()}
                        >
                            <img src={MoodleIcon} alt='Ícone do Moodle' />
                            Entrar com o Moodle
                        </button>
                    </>
                )}
            </LoginBox>
        </div>
    );
};
